import React, { useState } from "react";

//apollo
import { ApolloClient } from "apollo-client";
import { ApolloConsumer } from "react-apollo";

//components
import { LightButton } from "../../components/buttons/button";

//style imports
import styled from "styled-components";
import CV from "../../styles/variables";

interface IProps {
  className: String;
}

const LogoutButton: React.FunctionComponent = () => {
  const signOut = (client: ApolloClient<any>) => {
    client.clearStore();
    client.writeData({ data: { isLoggedIn: false } });
  };

  return (
    <ApolloConsumer>
      {client => (
        <CustomButton
          type="submit"
          onClick={() => {
            signOut(client);
          }}
        >
          Logout
        </CustomButton>
      )}
    </ApolloConsumer>
  );
};

const CustomButton = styled.button`
  color: white;
  background-color: ${CV.colorP2};
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  height: 32px;
  line-height: 1;
  transition: all 0.3s ease-in-out;
  :hover {
    background-color: ${CV.colorP3};
  }
  margin-right: 44px;
  margin-left: 32px;
  z-index: 0;
`;

export default LogoutButton;
